import { useSyncExternalStore } from 'react'
import { isInTelegram } from '../telegram'

// Та же граница, что у варианта desk в index.css: ≥768px и не внутри Telegram.
const QUERY = '(min-width: 768px)'

function subscribe(cb: () => void): () => void {
  const mql = window.matchMedia(QUERY)
  mql.addEventListener('change', cb)
  return () => mql.removeEventListener('change', cb)
}

function snapshot(): boolean {
  return !isInTelegram() && window.matchMedia(QUERY).matches
}

export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false)
}
